/**
 * Modal dos Termos de Servico / Politica de Privacidade, aberto pelos links do aceite no "Inscrever Beta".
 * Fica por cima do modal de inscricao (portal no <body>, z-index acima). Texto em legalTexts.ts. CSS em beta.css.
 */
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { PRIVACY, TERMS } from './legalTexts';

export type LegalTab = 'terms' | 'privacy';

type Props = {
  tab: LegalTab;
  onTab: (tab: LegalTab) => void;
  onClose: () => void;
  onAccept: () => void;
};

export function LegalModal({ tab, onTab, onClose, onAccept }: Props) {
  const doc = tab === 'terms' ? TERMS : PRIVACY;
  return createPortal(
    <div className="nxb-overlay nxb-overlay--legal" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="nxb-modal nxb-legal" role="dialog" aria-modal="true" aria-labelledby="nxb-legal-title">
        <button type="button" className="nxb-close" onClick={onClose} aria-label="Fechar">
          <X size={20} />
        </button>
        <div className="nxb-legal__tabs" role="tablist">
          <button type="button" role="tab" aria-selected={tab === 'terms'} onClick={() => onTab('terms')}>
            Termos de Serviço
          </button>
          <button type="button" role="tab" aria-selected={tab === 'privacy'} onClick={() => onTab('privacy')}>
            Política de Privacidade
          </button>
        </div>
        <div className="nxb-legal__body" key={tab}>
          <h2 id="nxb-legal-title" className="nxb-legal__title">
            {doc.title}
          </h2>
          {doc.intro && <p>{doc.intro}</p>}
          {doc.sections.map((s) => (
            <section key={s.heading}>
              <h3>{s.heading}</h3>
              <ol>
                {s.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            </section>
          ))}
        </div>
        <div className="nxb-legal__actions">
          <button type="button" className="nxb-ghost" onClick={onClose}>
            Fechar
          </button>
          <button type="button" className="nxb-submit" onClick={onAccept}>
            Li e aceito
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
